// Hook: PUT /company/users/{userId}

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { ICompanyUserPermissions, TCompanyRole } from 'api/types/company';

export interface IRequest {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;

  company_location_id?: number | null;
  company_department_id?: number | null;
  company_role?: TCompanyRole | null;
  is_available?: boolean;

  user_limit_enabled?: boolean;
  user_limit_period?: 'm' | 'q' | 'y' | null;
  user_limit_amount?: string | null;
  user_limit_visible_to_user?: boolean;

  permissions?: ICompanyUserPermissions;
  approving_manager_user_id?: number | null;
  approving_admin_user_id?: number | null;
  allow_over_limit_with_approval?: boolean;
  auto_approval_enabled?: boolean;
  auto_approval_threshold?: string | null;
}

export interface IVariables {
  userId: number;
  data: IRequest;
}

type IResponse = ICommandResponseSuccess;

const putCompanyUser = (userId: number, data: IRequest): Promise<IResponse> =>
  axios.put(`/company/users/${userId}`, data);

export const usePutCompanyUser = (
  options?: UseMutationOptions<IResponse, IError, IVariables>
) =>
  useMutation(({ userId, data }: IVariables) => putCompanyUser(userId, data), options);
